// Module
var code = "<h1 id=\"no-documentation-found\">No Documentation Found</h1> <p>Apologies for the inconvenience, but we cant seem to find any documentation for your selection.</p> ";
// Exports
module.exports = code;